<template>
  <modal v-if="isOpen" class-name="static-info-modal" @close="$emit('close')">
    <template #body>
      <div>
        <h1 class="page-headline">
          Bonitätsprüfung
        </h1>
        <p>
          Mit der Zustimmung zur Bonitätsprüfung erteilen Sie uns Ihre ausdrückliche Einwilligung,
          dass PKW.de Digital Mobility Solutions GmbH im Rahmen der Kaufabwicklung der SCHUFA Holding AG Daten über
          die Beantragung, Aufnahme und Beendigung dieser Vereinbarung übermittelt und Auskünfte
          über Sie von der SCHUFA erhält (vgl. auch § 4 der umseitigen AGB)
        </p>
        <p>
          Mehr Informationen dazu finden Sie in unserer
          <a href="https://www.pkw.de/datenschutz/">Datenschutzerklärung</a>.
        </p>
      </div>
    </template>
  </modal>
</template>

<script>
import Modal from '../common/Modal';

export default {
  components: {
    Modal,
  },
  props: ['isOpen'],
};
</script>
